module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('VDialog', {
    staticClass: "vue-alert",
    attrs: {
      "mask-transition": _vm.maskTransition,
      "dialog-transition": _vm.dialogTransition
    },
    on: {
      "on-hide": function($event) {
        _vm.$emit('on-hide')
      },
      "on-show": function($event) {
        _vm.$emit('on-show')
      }
    },
    model: {
      value: (_vm.showValue),
      callback: function($$v) {
        _vm.showValue = $$v
      },
      expression: "showValue"
    }
  }, [_c('div', {
    staticClass: "vue-popout"
  }, [_c('div', {
    staticClass: "main"
  }, [_c('div', {
    staticClass: "top"
  }, [_c('div', {
    staticClass: "paper"
  }, [_c('img', {
    attrs: {
      "src": _vm.content.Img
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "login"
  }, [_c('p', [_vm._v(_vm._s(_vm.content.Name))])])]), _vm._v(" "), _c('div', {
    staticClass: "big"
  }, [_c('ul', [_c('li', [_c('span', {
    staticClass: "svg"
  }, [_vm._v("Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.Name),
      expression: "content.Name"
    }],
    staticClass: "text",
    domProps: {
      "value": (_vm.content.Name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.content, "Name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "svg"
  }, [_vm._v("Title")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.Title),
      expression: "content.Title"
    }],
    staticClass: "text",
    domProps: {
      "value": (_vm.content.Title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.content, "Title", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "svg"
  }, [_vm._v("Href")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.Href),
      expression: "content.Href"
    }],
    staticClass: "text",
    domProps: {
      "value": (_vm.content.Href)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.content, "Href", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "svg"
  }, [_vm._v("Img")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.Img),
      expression: "content.Img"
    }],
    staticClass: "text",
    domProps: {
      "value": (_vm.content.Img)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.content, "Img", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "svg"
  }, [_vm._v("Num")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.Num),
      expression: "content.Num"
    }],
    staticClass: "text",
    domProps: {
      "value": (_vm.content.Num)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.content, "Num", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "svg"
  }, [_vm._v("New")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.New),
      expression: "content.New"
    }],
    staticClass: "text",
    domProps: {
      "value": (_vm.content.New)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.content, "New", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "footer btns"
  }, [_c('a', {
    staticClass: "btn",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm._onHide
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('a', {
    staticClass: "btn",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.add
    }
  }, [_vm._v("Ok")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-157e70c6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/v-list/copy.vue
// module id = 153
// module chunks = 1